// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner-_CykhA","paymentMethod":"paymentMethod-UnjXfu"};